<template>
  <div class="About">
    <PageHero title="About" lede="Since 2017, Ten Factor Growth has helped technology companies accelerate their growth and potential for success. I provide consulting on technology strategy, architecture, product management, and operational growth." />

    <section class="section">
      <div class="container">
        <div class="prose stack" style="margin-bottom:56px">
          <p>Each company stage requires different levels of process, decision
            making, technological sophistication and partnerships. Processes,
            staff, and technology must adapt to fit your company's stage and
            capabilities. Startups often struggle to find top talent, which can
            result in execution errors slowing growth. As a company grows,
            process and tech must mature to support distributed communications
            and decision making.</p>
          <p>I've managed companies through the early seed stage up to
            established growth stages. I've managed technology with hundreds of
            developers and dozens of products. I've applied these approaches as
            an advisor and part-time consultant in consumer products,
            healthtech, edtech, robotics, and general enterprise.</p>
          <p><a href="mailto:brian@tenfactorgrowth.com">Contact me</a> if you are
            struggling with technology and growth.</p>
        </div>

        <div class="split">
          <div class="stack prose">
            <h2>Brian Eberman, Ph.D.</h2>
            <p>With over 30 years of experience bringing new technologies and
              companies to market, I provide product strategy, software
              technology development, and operational execution consulting and
              advising to technology companies at any stage.</p>
            <p>With a technical background in AI, statistics, robotics, and
              speech recognition, I often work on problems involving distributed
              computation or data driven decisions.</p>
          </div>
          <img class="headshot" src="images/headshot.jpg" alt="Brian Eberman">
        </div>

        <div class="prose stack" style="margin-top:48px">
          <ul class="highlights">
            <li>At Nuance, I led the transformation from a proprietary API
              architecture to an open web based architecture that now represents
              the primary way call-center speech applications are delivered.</li>
            <li>The mobile first, services based, integrated online tutoring
              architecture that I drove at EnglishCentral, an edtech company,
              created ongoing significant growth for the company.</li>
            <li>At Jibo, the consumer robotics company, I quickly delivered a new
              software approach that restructured the software architecture to
              meet the business needs of the company. This architecture moved the
              company from an application install approach to a distributed
              model combining local computation with application control in the
              cloud.</li>
            <li>At CourseAdvisor, I helped design statistical decision processes
              for optimizing landing pages to advertisements, selecting
              advertising, and improving lead conversion rates.</li>
            <li>At Exos, I designed a distributed computation system to provide
              haptic feedback with a force controlled joystick. Microsoft
              acquired Exos and applied this design to create the Sidewinder
              Joystick, selling over 100M units.</li>
          </ul>
          <p>I bring decades of experience in distributed systems, speech
            technology, robotics, and data analytics. This includes a Ph.D. in
            robotics and AI, over 14 years running early stage companies, and 10
            years in speech recognition including as Vice President of Product
            Management at Nuance Communications.</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageHero from '@/components/PageHero'

export default {
    name: 'About',
    title: 'About - Ten Factor Growth',
    components: { PageHero }
}
</script>
